import { createAction, props } from '@ngrx/store';
import { DocumentEntity } from './documents.models';

export const initDocuments = createAction(
  '[Filter Results Page] Get Documents',
  props<{
    id?: number;
    filterValues?: number[];
    language?: string;
    searchTerm?: string;
    page?: number;
    sort?: string;
  }>(),
);

export const updateParentId = createAction(
  '[Filter Results Page] Update parent ID',
  props<{ id: number | undefined }>(),
);

export const setCurrentDocument = createAction(
  '[Documents] Set Current Document',
  props<{ document: DocumentEntity }>(),
);

export const loadDocumentsSuccess = createAction('[Documents/Api] Get Documents Success', props<{ data: any }>());

export const loadDocumentsFailure = createAction('[Documents/Api] Get Documents Failure', props<{ error: any }>());

export const updateDocumentBookmark = createAction(
  '[Documents] Update Document Bookmark',
  props<{ documentId: number; isBookmarked: boolean }>(),
);
